import { GMN } from "@nens/brostar/openapi-client";
import { qualityRegimeOptionsType } from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const gmnInformation: SearchOption<keyof GMN, keyof GMN>[] = [
  { key: "broId", label: "BRO-ID" },
  { key: "name", label: "Naam" },
  { key: "startDateMonitoring", label: "Startdatum" },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((option) => ({ key: option, label: option })),
  },
];
